import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import Div from '@jarvis.oddle/core/components/Div'
import breakpoint from 'src/utils/styledComponentsBreakpoint'
import Modal, { PrevButton } from '@jarvis.oddle/core/components/Modal'
import { H4 } from '@jarvis.oddle/core/components/Typo'
import { colorConstants } from '@jarvis.oddle/core/theme/default'

const MobileHeaderContainer = styled(Div)`
  background-color: ${colorConstants.white};
  position: sticky;
  top: 0;
  z-index: 2;
  ${breakpoint('desktop')`
    display: none;
  `}
`
const StyledHeadingText = styled(H4)`
  color: ${(props) => props.theme.colorHeadingsFont};
`

interface OrderHeaderMobileProps {
  headingText: string
  onClickBack?: () => void
}

const OrderHeaderMobile = ({ headingText, onClickBack }: OrderHeaderMobileProps): JSX.Element => {
  const theme = useContext(ThemeContext)
  return (
    <MobileHeaderContainer>
      <Modal.Header>
        <StyledHeadingText bold>{headingText}</StyledHeadingText>
        {onClickBack && (
          <PrevButton
            data-testid='orderHeaderMobile.prevBtn'
            onClick={onClickBack}
            fill={theme.colorHeadingsFont}
          />
        )}
      </Modal.Header>
    </MobileHeaderContainer>
  )
}

export default OrderHeaderMobile
